import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#59AD3B",
      d: "M15.333 8c0 .64-.786 1.168-.944 1.758-.162.61.249 1.46-.06 1.993-.314.543-1.257.608-1.697 1.048-.44.44-.505 1.383-1.048 1.697-.534.309-1.383-.102-1.993.06-.59.158-1.118.944-1.758.944-.64 0-1.167-.786-1.757-.944-.61-.162-1.46.249-1.994-.06-.543-.314-.608-1.257-1.048-1.697-.44-.44-1.383-.505-1.697-1.048-.309-.534.102-1.383-.06-1.993C1.119 9.168.333 8.64.333 8c0-.64.786-1.168.944-1.758.162-.61-.249-1.46.06-1.993.314-.543 1.257-.608 1.697-1.048.44-.44.505-1.384 1.048-1.697.534-.309 1.384.102 1.994-.06C6.666 1.286 7.193.5 7.833.5c.64 0 1.168.786 1.758.944.61.162 1.46-.249 1.993.06.543.313.608 1.257 1.048 1.697.44.44 1.383.505 1.697 1.048.309.534-.102 1.384.06 1.994.158.59.944 1.117.944 1.757Z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FFFCEE",
      d: "M10 5.765 7.145 8.62l-1.48-1.479a.823.823 0 0 0-1.163 1.164l2.076 2.076a.801.801 0 0 0 1.132 0l3.453-3.452A.823.823 0 0 0 10 5.765Z"
    }, null, -1)
  ])))
}
export default { render: render }